import React from 'react';
import styled from 'styled-components';

import { color, device } from 'theme';
import { Text } from 'theme/titles';

const TvChannelText = styled(Text)`
  font-size: 0.8rem;
  color: ${color.lightGrey};
  letter-spacing: 0.1rem;
  padding: 2px;

  @media ${device.tablet} {
    font-size: 1.3rem;
  }

  @media ${device.laptopL} {
    font-size: 1.5rem;
  }
`;

export const TvChannel = ({ channel }) => {
  // NOTE: Added this in late 2025 before changing to dynadot
  // Someone had complained booo - can probably removw
  // Hide TV channel for bravestime.com domain
  const isBravestime =
    typeof window !== 'undefined' &&
    window.location.hostname.includes('bravestime.com');

  if (isBravestime) {
    return null;
  }

  return (
    <TvChannelText>
      {channel !== '' && channel !== null ? <span>on {channel}</span> : null}
    </TvChannelText>
  );
};
